import WaitingRoomController from './waitingRoomController'

document.addEventListener('DOMContentLoaded', function () {
  const startWaitingRoom = (
    id: string,
    hubUrl: string,
    waitingRoomUrl: string,
    completedEvent: string
  ) => {
    const controller = new WaitingRoomController(
      id,
      hubUrl,
      waitingRoomUrl,
      completedEvent
    )

    controller.connect().catch(error => {
      console.warn('Unable to start waiting room connection.', error)
      void controller.checkWaitingRoom()
    })
  }

  // get waiting room info
  const waitingRoomWrapper = document.querySelector('[data-waitingroom]')

  if (!waitingRoomWrapper) return

  const id = waitingRoomWrapper.getAttribute('data-waitingroom-id')
  const hubUrl = waitingRoomWrapper.getAttribute('data-waitingroom-hub-url')
  const waitingRoomUrl = waitingRoomWrapper.getAttribute('data-waitingroom-url')
  const completedEvent = waitingRoomWrapper.getAttribute(
    'data-waitingroom-completed-event'
  )

  if (!id || !hubUrl || !waitingRoomUrl || !completedEvent) return

  // start socket
  startWaitingRoom(id, hubUrl, waitingRoomUrl, completedEvent)
})
